export default class DatiCompany{
    RagioneSociale;
    Indirizzo;
    PartitaIva;
    
}